module.exports = ".message {\n  font-size: 20px;\n  color: #3c763d !important; }\n\n.message .fa {\n  font-size: 20px; }\n"